import { filter, MonoTypeOperatorFunction, switchMap } from 'rxjs';
import { inject } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { HealthCheckService } from '../services/health-check.service';

export function isAuthenticatedAndHealthy$(): MonoTypeOperatorFunction<boolean> {
  const authService = inject(AuthService);
  const healthCheckService = inject(HealthCheckService);
  return (source) =>
    source.pipe(
      switchMap(() => authService.isAuthenticated$),
      filter((isAuth) => isAuth),
      switchMap(() => healthCheckService.healthCheck$),
    );
}
